import { render, staticRenderFns } from "./ProcurementsTable.vue?vue&type=template&id=7da8664d"
import script from "./ProcurementsTable.vue?vue&type=script&lang=js"
export * from "./ProcurementsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports